import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastManagerProp, withToastManager } from 'react-toast-notifications';

import { apiErrorHandler } from 'core/errors';
import { API, getCancelToken, request, RequestCancelToken } from 'redux/api';
import { RootState } from 'redux/reducers';
import { pluralize } from 'utils';

import StudentAnalyticsTable from './StudentAnalyticsTable';

interface GetStudentAnalyticsResoponse extends MessageResponse {
  students: StudentAggregateAnalytics[];
}

export const getStudentAnalytics = async (cancelToken: RequestCancelToken) => {
  const { students } = await request<GetStudentAnalyticsResoponse>({
    url: API.STUDENT_AGGREGATE_ANALYTICS,
    method: 'get',
    cancelToken: cancelToken,
  });

  return students;
};

interface StudentAnalyticsProps extends ToastManagerProp {
  courseId?: string;
  appContext: AppContext | undefined;
}

interface StudentAnalyticsState {
  isLoading: boolean;
  students: StudentAggregateAnalytics[];
  showStudentDetails: boolean;
  showStudentDetailsFor: string;
}

class StudentAnalytics extends Component<StudentAnalyticsProps, StudentAnalyticsState> {
  apiSources = getCancelToken();

  state: StudentAnalyticsState = {
    isLoading: true,
    students: [],
    showStudentDetails: false,
    showStudentDetailsFor: '',
  };

  async getStudentAnalytics() {
    return getStudentAnalytics(this.apiSources.token);
  }

  async componentDidMount() {
    try {
      this.apiSources = getCancelToken();
      const students = await this.getStudentAnalytics();
      this.setState({ students, isLoading: false });
    } catch (err) {
      apiErrorHandler(this.props.toastManager, err, () => {
        this.setState({ isLoading: false });
      });
    }
  }

  componentWillUnmount() {
    this.apiSources.cancel();
  }

  render() {
    const { isLoading, students } = this.state;
    const { appContext } = this.props;
    return (
      <article className='section'>
        <div className='section__header'>
          <h3 className='section__title'>
            {isLoading
              ? 'Loading insights...'
              : students.length
              ? `Learning Insights available for ${students.length} ${pluralize(students.length, 'student')}`
              : 'Learning Insights unavailable for any student'}
          </h3>
        </div>
        <div className='section__body'>
          {appContext === 'course' ? (
            <p className='section__tip'>
              Insights for any student are first available two weeks after the course has been published on
              Acadly
            </p>
          ) : (
            <p className='section__tip'>
              Insights for any student are first available two weeks after at least one of their enrolled
              courses have been published on Acadly
            </p>
          )}
          <StudentAnalyticsTable students={students} />
        </div>
      </article>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  appContext: state.getAccess?.context,
});

export default connect(mapStateToProps)(withToastManager(StudentAnalytics));
